import React, {
    useEffect,
    useRef,
    useState,
    Fragment,
} from "react";
import ReactDOM from "react-dom/client";
import { Combobox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon, QuestionMarkCircleIcon } from "@heroicons/react/20/solid";
import useSWR from "swr";

import {
    CUSTOMER_EXISTING,
    CUSTOMER_NEW,
    CUSTOMER_SIGNUP,
    EMAIL,
    PASSWORD,
    EXISTING_PASSWORD,
    COMPANY_NAME,
    CONTACT_NAME,
    PHONE,
    STREET_ADDRESS,
    CITY,
    STATE,
    ZIP_CODE,
    // WORKING_WITH_USPS_REP,
    // HOW_DID_YOU_HEAR_ABOUT_US,
    USPS_REPRESENTATIVE,
    EXISTING_CUSTOMER,
    AGREED_TO_TERMS,
    SUBSCRIBED_TO_MARKETING,
    SALES_REP_ASSIGNEMENT_CONSENT,
} from "../helpers/constants";
import usStates from "../utils/usStates";
import capitalizeNameLowerCaseRest from "../utils/capitalizeNameLowerCaseRest";
import TagManager from 'react-gtm-module';

import IntroImage from "../images/xps-connect.jpg";
import XPSLogo from "../images/xps-logo.png";
import TestimonialLogo from '../images/testimonial-logo.png';
import PlusPattern from "../images/plus.svg";

import "../styles/app.css";

const searchParams = new URLSearchParams(document.location.search);
const repUsername = searchParams.get("rep") || null;

const tagManagerArgs = {
    gtmId: 'GTM-KRDDH7S'
};

TagManager.initialize(tagManagerArgs);

function App() {
    const [customer, setCustomer] = useState(CUSTOMER_NEW);
    const [existingCustomer, setExistingCustomer] = useState(0)

    const formRef = useRef(null);

    return (
        <div
            className="min-h-full"
        >
            <div
                className="relative z-10 bg-white lg:flex lg:min-h-full lg:fixed lg:w-1/2 shadow-xl shadow-black"
                style={{ backgroundImage: `url(${PlusPattern})` }}
            >
                <div className="w-full">
                    <div className="flex flex-col gap-12 px-8 pb-8 pt-8 lg:pt-12">
                        <a href="https://www.xpsconnect.com/">
                            <img
                                className={"relative z-10 max-h-[150px] lg:w-[286px] lg:max-h-[231px] mx-auto"}
                                src={IntroImage}
                                alt="XPS Connect"
                            />
                        </a>
                        <section className="z-10 hidden lg:block overflow-hidden px-6 lg:px-8">
                            <div className="relative mx-auto my-12 max-w-2xl">
                                <figure className="flex flex-col gap-4">
                                    <div className="relative">
                                        <QuotesSvg />
                                        <blockquote className="text-base font-semibold leading-8 text-gray-900 sm:text-lg sm:leading-9">
                                            <p><strong>XPS has been extremely helpful with setting up and maintaining our integration with Shopify</strong></p>
                                            <p>Adjusting settings and changing preferences is very easy. They have been pivotal in ensuring that our shipping goes smoothly. They are always readily available to help with any issues that may occur or answer any questions. Our rep, Andrew, is absolutely on top of anything we inquire about. He often notices issues before we do and is quick to fix it.</p>
                                            <p><strong>We would definitely recommend XPS to other Shopify store owners.</strong></p>
                                        </blockquote>
                                    </div>
                                    <div className="flex items-center gap-4">
                                        <div className="w-16 lg:w-72">
                                            <img
                                                className="p-4 rounded-xl bg-indigo-50 lg:rounded-3xl"
                                                src={TestimonialLogo}
                                                alt="Testimonial Logo"
                                            />
                                        </div>
                                        <figcaption className="text-base lg:col-start-1 lg:row-start-3">
                                            <div className="font-semibold text-gray-900">Clara Mathis</div>
                                            <div className="mt-1 text-gray-500">Sr. ECommerce Marketing Manager</div>
                                        </figcaption>
                                    </div>
                                </figure>
                            </div>
                        </section>
                    </div>
                </div>
                <div className="absolute inset-0 bg-gradient-to-tl from-white" />
            </div>
            <div className="relative mx-auto max-w-2xl lg:max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:h-full">
                <div className="lg:ml-auto lg:h-full lg:w-1/2 lg:pl-10 lg:flex lg:flex-col lg:content-center">
                    {!customer && (
                        <div>
                            <h2 className="text-lg font-semibold text-[#e6e8ec]">
                                XPS Connect
                            </h2>
                            <p className="mt-2 text-3xl font-bold tracking-tight text-white sm:text-4xl">
                                Sign up Now
                            </p>
                            <p className="mt-3 text-lg text-[#e6e8ec]">
                                Explore the features, integrations, and benefits
                                our shipping software has to offer by signing up
                                for a free account with USPS Merchant Rates.
                            </p>
                        </div>
                    )}
                    <div>
                        {!customer && (
                            <button
                                className="relative button text-white bg-xps-primary hover:bg-xps-primary-600 flex"
                                onClick={() => setCustomer(CUSTOMER_EXISTING)}
                            >
                                <img
                                    className="absolute left-4 mr-6 w-[50px] self-center"
                                    src={XPSLogo}
                                    alt="XPS Ship"
                                />
                                XPS Ship Customer Signup
                            </button>
                        )}

                        {!customer && (
                            <button
                                className="button mt-3 rounded-md shadow"
                                onClick={() => setCustomer(CUSTOMER_NEW)}
                            >
                                New Customer Signup
                            </button>
                        )}

                        {customer && customer !== CUSTOMER_SIGNUP && (
                            <>
                                {/* <button
                                    className="button"
                                    onClick={() => {
                                        setFormHeight(0);
                                        setContainerHeight("100%");
                                        setCustomer("");
                                    }}
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 24 24"
                                        strokeWidth={1.5}
                                        stroke="currentColor"
                                        className="w-6 h-6 text-xps-connect-secondary mr-2"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            d="M6.75 15.75L3 12m0 0l3.75-3.75M3 12h18"
                                        />
                                    </svg>
                                    Back
                                </button> */}
                                <Form
                                    customer={customer}
                                    setCustomer={setCustomer}
                                    setExistingCustomer={setExistingCustomer}
                                    formRef={formRef}
                                />
                            </>
                        )}

                        {customer === CUSTOMER_SIGNUP && (
                            <>
                                <div className="mt-3 text-lg text-[#e6e8ec]">
                                    {existingCustomer === 1 ? "You've been signed up for XPS Connect!" : "We've sent a verification link to your email. Please check your email and click on the link to log in."}
                                </div>
                                {existingCustomer === 1 && (
                                    <div>
                                    <a
                                        className="button mt-6"
                                        href="https://ship.xpsconnect.com"
                                    >
                                        Sign in now
                                    </a>
                                </div>
                                )}
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}

function QuotesSvg() {
    return (
        <svg viewBox="0 0 162 128" fill="none" aria-hidden="true" className="absolute -top-12 -left-6 -z-10 h-32 stroke-gray-900/10">
            <path id="b56e9dab-6ccb-4d32-ad02-6b4bb5d9bbeb" d="M65.5697 118.507L65.8918 118.89C68.9503 116.314 71.367 113.253 73.1386 109.71C74.9162 106.155 75.8027 102.28 75.8027 98.0919C75.8027 94.237 75.16 90.6155 73.8708 87.2314C72.5851 83.8565 70.8137 80.9533 68.553 78.5292C66.4529 76.1079 63.9476 74.2482 61.0407 72.9536C58.2795 71.4949 55.276 70.767 52.0386 70.767C48.9935 70.767 46.4686 71.1668 44.4872 71.9924L44.4799 71.9955L44.4726 71.9988C42.7101 72.7999 41.1035 73.6831 39.6544 74.6492C38.2407 75.5916 36.8279 76.455 35.4159 77.2394L35.4047 77.2457L35.3938 77.2525C34.2318 77.9787 32.6713 78.3634 30.6736 78.3634C29.0405 78.3634 27.5131 77.2868 26.1274 74.8257C24.7483 72.2185 24.0519 69.2166 24.0519 65.8071C24.0519 60.0311 25.3782 54.4081 28.0373 48.9335C30.703 43.4454 34.3114 38.345 38.8667 33.6325C43.5812 28.761 49.0045 24.5159 55.1389 20.8979C60.1667 18.0071 65.4966 15.6179 71.1291 13.7305C73.8626 12.8145 75.8027 10.2968 75.8027 7.38572C75.8027 3.6497 72.6341 0.62247 68.8814 1.1527C61.1635 2.2432 53.7398 4.41426 46.6119 7.66522C37.5369 11.6459 29.5729 17.0612 22.7236 23.9105C16.0322 30.6019 10.618 38.4859 6.47981 47.558L6.47976 47.558L6.47682 47.5647C2.4901 56.6544 0.5 66.6148 0.5 77.4391C0.5 84.2996 1.61702 90.7679 3.85425 96.8404L3.8558 96.8445C6.08991 102.749 9.12394 108.02 12.959 112.654L12.959 112.654L12.9646 112.661C16.8027 117.138 21.2829 120.739 26.4034 123.459L26.4033 123.459L26.4144 123.465C31.5505 126.033 37.0873 127.316 43.0178 127.316C47.5035 127.316 51.6783 126.595 55.5376 125.148L55.5376 125.148L55.5477 125.144C59.5516 123.542 63.0052 121.456 65.9019 118.881L65.5697 118.507Z" />
            <use href="#b56e9dab-6ccb-4d32-ad02-6b4bb5d9bbeb" x="86" />
        </svg>
    )
}

const root = ReactDOM.createRoot(document.getElementById("app"));
root.render(<App />);

const defaultPassowrd = window.settings.isDevMode && window.settings.devPassword ? window.settings.devPassword : ""

const currentCustomerInitialState = {
    [EMAIL]: "",
    [USPS_REPRESENTATIVE]: "",
    [EXISTING_PASSWORD]: defaultPassowrd,
    [EXISTING_CUSTOMER]: 1,
    [AGREED_TO_TERMS]: false,
    [SUBSCRIBED_TO_MARKETING]: true,
    trustDevice: false
};

const newCustomerInitialState = {
    [EMAIL]: "",
    [PASSWORD]: defaultPassowrd,
    [COMPANY_NAME]: "",
    [CONTACT_NAME]: "",
    [PHONE]: "",
    [STREET_ADDRESS]: "",
    [CITY]: "",
    [STATE]: "",
    [ZIP_CODE]: "",
    // [WORKING_WITH_USPS_REP]: "",
    // [HOW_DID_YOU_HEAR_ABOUT_US]: "",
    [USPS_REPRESENTATIVE]: "",
    [EXISTING_CUSTOMER]: 0,
    [AGREED_TO_TERMS]: false,
    [SUBSCRIBED_TO_MARKETING]: true,
    [SALES_REP_ASSIGNEMENT_CONSENT]: true,
    trustDevice: false
};

const errorsInitialState = {};

function Form({ customer, setCustomer, setExistingCustomer, formRef, rep }) {
    const initialFormState =
        customer === CUSTOMER_EXISTING
            ? currentCustomerInitialState
            : newCustomerInitialState;

    // if (rep) {
    //     initialFormState[WORKING_WITH_USPS_REP] = "Yes";
    // }

    const [formState, setFormState] = useState(initialFormState);
    const [errors, setErrors] = useState(errorsInitialState);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    useEffect(() => {
        if (!formState[EMAIL]) {
            formRef.current.children[0][EMAIL].focus();
        } else if (customer === CUSTOMER_EXISTING) {
            formRef.current.children[0][EXISTING_PASSWORD].focus();
        } else {
            formRef.current.children[0][PASSWORD].focus();
        }
    }, [customer]);

    async function handleSubmit() {
        const hasError = verifyForm();
        if (hasError) {
            return;
        }

        grecaptcha.ready(function() {
            grecaptcha.execute(recaptchaSiteKey, {action: 'submit'}).then(async recaptchaToken => {
                const { 
                    fingerprint, 
                    fingerprintJson 
                } = getBrowserFingerprint()

                let formParams = {
                    ...formState,
                    recaptchaToken,
                    fingerprint, 
                    fingerprintJson 
                }

                setIsSubmitting(true);

                const res = await fetch("", {
                    method: "POST",
                    body: Object.keys(formParams).map(key => encodeURIComponent(key) + '=' + encodeURIComponent(formParams[key])).join('&'),
                    headers: {
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                });
                const resJson = await res.json();
                if (resJson.success) {
                    setIsSubmitting(false);
                    setExistingCustomer(formState[EXISTING_CUSTOMER])
                    setCustomer(CUSTOMER_SIGNUP);
                } 
                else {
                    console.error(resJson);
                    setIsSubmitting(false);
                    setErrors((state) => ({
                        ...state,
                        form: {
                            message: resJson.error,
                        },
                    }));
                }
            })
        });
    }

    function handleChange(e, input) {
        let name;
        let value;

        if (input?.type === STATE) {
            name = STATE;
            value = input?.value?.abbreviation;
        }
        else if (input?.type === USPS_REPRESENTATIVE) {
            name = USPS_REPRESENTATIVE;
            value = input?.value?.username;
        }
        else {
            name = e?.target?.name;
            value = e?.target?.type === 'checkbox' ? e.target.checked : e?.target?.value;
        }

        const updatedState = {};

        // if (name === WORKING_WITH_USPS_REP && value === "No") {
        //     updatedState[USPS_REPRESENTATIVE] = "";
        // }
        // if (name === WORKING_WITH_USPS_REP && value === "Yes") {
        //     updatedState[HOW_DID_YOU_HEAR_ABOUT_US] = "";
        // }

        setFormState((state) => ({ ...state, ...updatedState, [name]: value }));
    }

    function checkEmail() {
        (async function () {
            let formData = new FormData();
            formData.append(EMAIL, formState[EMAIL]);

            const res = await fetch("checkemail", {
                method: "POST",
                body: formData,
            });
            const resJson = await res.json();

            if (resJson.userExists) {
                if (window.settings.isDevMode && !confirm('This email already exists. Do you want to switch to login mode? [dev mode only message]')) {
                    return
                }
                setCustomer(CUSTOMER_EXISTING);
                setFormState({
                    ...currentCustomerInitialState,
                    [EMAIL]: formState[EMAIL],
                    [USPS_REPRESENTATIVE]: formState[USPS_REPRESENTATIVE],
                });
            } else {
                setCustomer(CUSTOMER_NEW);
                setFormState({
                    ...newCustomerInitialState,
                    [EMAIL]: formState[EMAIL],
                    [USPS_REPRESENTATIVE]: formState[USPS_REPRESENTATIVE],
                    [EXISTING_CUSTOMER]: 0,
                });
            }
        })();
    }

    function verifyForm() {
        let formErrors = {};

        if (formState[EXISTING_CUSTOMER] === 0) {
            if (
                !/^[\d\(\)\-]{10,}$/.test(
                    formState[PHONE]
                )
            ) {
                formErrors[PHONE] = {
                    message: "Please add a valid phone number including the area code.",
                };
            }
            if (!formState[STATE]) {
                formErrors[STATE] = { message: "Please select a state." };
            }
            if (
                !/^\d{5}(?:[-\s]\d{4})?$/.test(formState[ZIP_CODE])
            ) {
                formErrors[ZIP_CODE] = {
                    message: "Please add a valid zip code.",
                };
            }
            // if (
            //     !formState[USPS_REPRESENTATIVE] &&
            //     formState[WORKING_WITH_USPS_REP] === "Yes"
            // ) {
            //     formErrors[USPS_REPRESENTATIVE] = {
            //         message: "Please select a USPS representative.",
            //     };
            // }
        }

        if (formState[EXISTING_CUSTOMER] === 1) {
            // if (!formState[USPS_REPRESENTATIVE]) {
            //     formErrors[USPS_REPRESENTATIVE] = {
            //         message: "Please select a USPS representative.",
            //     };
            // }
        }

        if (!formState[AGREED_TO_TERMS]) {
            formErrors[AGREED_TO_TERMS] = {
                message: "Please agree to the terms and conditions.",
            };
        }

        const formErrorsKeys = Object.keys(formErrors);

        if (formErrorsKeys.length !== 0) {
            const focus = formErrorsKeys[0];
            if (focus !== STATE) {
                formRef.current.children[0][focus].scrollIntoView({
                    behavior: "auto",
                    block: "center",
                    inline: "center",
                });
                formRef.current.children[0][focus].focus();
            }
            setErrors(formErrors);
            return true;
        }

        setErrors(errorsInitialState);
        return false;
    }

    return (
        <div className="relative p-10 rounded-md bg-white" ref={formRef}>
            <form
                className="space-y-2 divide-y divide-gray-300"
                onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                }}
            >
                {customer === CUSTOMER_EXISTING && (
                    <div className="form-inner-container">
                        <div>
                            <div>
                                <div>
                                    <h3 className="text-lg font-medium leading-6 text-gray-900">
                                        Account Information
                                    </h3>
                                    <p className="mt-1 text-sm text-xps-connect-primary-600 bg-slate-50 rounded-md border border-slate-200 px-3 py-3">
                                        You already have an XPS Ship account.
                                        Complete this form to switch to XPS
                                        Connect.
                                    </p>
                                </div>
                                <div className="section-container">
                                    <div className="input-row pt-0">
                                        <label
                                            className="input-label"
                                            htmlFor={EMAIL}
                                        >
                                            Email (Username){" "}
                                            <span className="text-red-600">
                                                *
                                            </span>
                                        </label>
                                        <div className="input-container">
                                            <input
                                                type={EMAIL}
                                                name={EMAIL}
                                                value={formState[EMAIL]}
                                                onChange={handleChange}
                                                onBlur={checkEmail}
                                                required
                                                className="input"
                                                autoComplete="email"
                                            />
                                        </div>
                                    </div>
                                    <div className="input-row">
                                        <label
                                            className="input-label"
                                            htmlFor={EXISTING_PASSWORD}
                                        >
                                            Enter Password{" "}
                                            <span className="text-red-600">
                                                *
                                            </span>
                                        </label>
                                        <div className="relative input-container">
                                            <input
                                                type={
                                                    showPassword
                                                        ? "text"
                                                        : "password"
                                                }
                                                name={EXISTING_PASSWORD}
                                                value={
                                                    formState[EXISTING_PASSWORD]
                                                }
                                                onChange={handleChange}
                                                required
                                                maxLength={200}
                                                className={`input${
                                                    errors?.[EXISTING_PASSWORD]
                                                        ? " input-invalid"
                                                        : ""
                                                }`}
                                                autoComplete="current-password"
                                            />
                                            <PasswordToggle
                                                showPassword={showPassword}
                                                setShowPassword={
                                                    setShowPassword
                                                }
                                            />
                                        </div>
                                        <div className="mt-2 text-red-600">
                                            {
                                                errors?.[EXISTING_PASSWORD]
                                                    ?.message
                                            }
                                        </div>
                                    </div>
                                    <div className="input-row">
                                        <label
                                            className="input-label"
                                            htmlFor={USPS_REPRESENTATIVE}
                                        >
                                            Search and select your USPS
                                            representative{" "}
                                            {/* <span className="text-red-600">
                                                *
                                            </span> */}
                                        </label>
                                        <div className="input-container">
                                            <ComboboxAutocomplete
                                                name={USPS_REPRESENTATIVE}
                                                handleChange={handleChange}
                                                rep={repUsername}
                                                inputErrors={errors}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {customer === CUSTOMER_NEW && (
                    <div className="form-inner-container">
                        <div>
                            <div>
                                <h3 className="text-lg font-medium leading-6 text-gray-900">
                                    Account Information
                                </h3>
                                <p className="mt-1 text-sm text-gray-500">
                                    This information will be used for your
                                    account.
                                </p>
                            </div>
                            <div className="section-container">
                                <div className="input-row">
                                    <label
                                        className="input-label"
                                        htmlFor={EMAIL}
                                    >
                                        Email (Username){" "}
                                        <span className="text-red-600">*</span>
                                    </label>
                                    <div className="input-container">
                                        <input
                                            type={EMAIL}
                                            name={EMAIL}
                                            value={formState[EMAIL]}
                                            onChange={handleChange}
                                            onBlur={checkEmail}
                                            required
                                            className="input"
                                            autoComplete="email"
                                        />
                                    </div>
                                </div>
                                <div className="input-row">
                                    <label
                                        className="input-label"
                                        htmlFor={PASSWORD}
                                    >
                                        Enter Password{" "}
                                        <span className="text-red-600">*</span>
                                    </label>
                                    <div className="relative input-container">
                                        <input
                                            type={
                                                showPassword
                                                    ? "text"
                                                    : "password"
                                            }
                                            name={PASSWORD}
                                            value={formState[PASSWORD]}
                                            onChange={handleChange}
                                            required
                                            maxLength={200}
                                            className={`input${
                                                errors?.[PASSWORD]
                                                    ? " input-invalid"
                                                    : ""
                                            }`}
                                            autoComplete="new-password"
                                        />
                                        <PasswordToggle
                                            showPassword={showPassword}
                                            setShowPassword={setShowPassword}
                                        />
                                    </div>
                                    <div className="mt-2 text-red-600">
                                        {errors?.[PASSWORD]?.message}
                                    </div>
                                </div>
                                <div className="input-row">
                                    <label
                                        className="input-label"
                                        htmlFor={COMPANY_NAME}
                                    >
                                        Company Name{" "}
                                        <span className="text-red-600">*</span>
                                    </label>
                                    <div className="input-container">
                                        <input
                                            type="text"
                                            name={COMPANY_NAME}
                                            value={formState[COMPANY_NAME]}
                                            onChange={handleChange}
                                            required
                                            className="input"
                                            autoComplete="organization"
                                        />
                                    </div>
                                </div>
                                <div className="input-row">
                                    <label
                                        className="input-label"
                                        htmlFor={CONTACT_NAME}
                                    >
                                        Contact Name{" "}
                                        <span className="text-red-600">*</span>
                                    </label>
                                    <div className="input-container">
                                        <input
                                            type="text"
                                            name={CONTACT_NAME}
                                            value={formState[CONTACT_NAME]}
                                            onChange={handleChange}
                                            required
                                            className="input"
                                            autoComplete="name"
                                        />
                                    </div>
                                </div>
                                <div className="input-row">
                                    <label
                                        className="input-label"
                                        htmlFor={PHONE}
                                    >
                                        Phone{" "}
                                        <span className="text-red-600">*</span>
                                    </label>
                                    <div className="input-container">
                                        <input
                                            type="text"
                                            name={PHONE}
                                            value={formState[PHONE]}
                                            onChange={handleChange}
                                            required
                                            className={`input${
                                                errors?.[PHONE]
                                                    ? " input-invalid"
                                                    : ""
                                            }`}
                                            autoCapitalize="tel"
                                        />
                                    </div>
                                    <div className="mt-2 text-red-600">
                                        {errors?.[PHONE]?.message}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-section">
                            <div>
                                <h3 className="text-lg font-medium leading-6 text-gray-900">
                                    Address Information
                                </h3>
                                <p className="mt-1 text-sm text-gray-500">
                                    Use a permanent address where you can
                                    receive mail.
                                </p>
                            </div>
                            <div className="section-container">
                                <div className="input-row">
                                    <label
                                        className="input-label"
                                        htmlFor={STREET_ADDRESS}
                                    >
                                        Street Address{" "}
                                        <span className="text-red-600">*</span>
                                    </label>
                                    <div className="input-container">
                                        <input
                                            type="text"
                                            name={STREET_ADDRESS}
                                            value={formState[STREET_ADDRESS]}
                                            onChange={handleChange}
                                            required
                                            className="input"
                                            autoComplete="address-line1"
                                        />
                                    </div>
                                </div>
                                <div className="input-row">
                                    <label
                                        className="input-label"
                                        htmlFor={CITY}
                                    >
                                        City{" "}
                                        <span className="text-red-600">*</span>
                                    </label>
                                    <div className="input-container">
                                        <input
                                            type="text"
                                            name={CITY}
                                            value={formState[CITY]}
                                            onChange={handleChange}
                                            required
                                            className="input"
                                            autoComplete="address-level2"
                                        />
                                    </div>
                                </div>
                                <div className="input-row">
                                    <label
                                        className="input-label"
                                        htmlFor={STATE}
                                    >
                                        State{" "}
                                        <span className="text-red-600">*</span>
                                    </label>
                                    <div className="input-container">
                                        <ComboboxAutocomplete
                                            name={STATE}
                                            handleChange={handleChange}
                                            initialData={usStates}
                                            inputErrors={errors}
                                        />
                                    </div>
                                    <div className="mt-2 text-red-600">
                                        {errors?.[STATE]?.message}
                                    </div>
                                </div>
                                <div className="input-row">
                                    <label
                                        className="input-label"
                                        htmlFor={ZIP_CODE}
                                    >
                                        Zip Code{" "}
                                        <span className="text-red-600">*</span>
                                    </label>
                                    <div className="input-container">
                                        <input
                                            type="text"
                                            name={ZIP_CODE}
                                            value={formState.zip_code}
                                            onChange={handleChange}
                                            required
                                            className={`input${
                                                errors?.[ZIP_CODE]
                                                    ? " input-invalid"
                                                    : ""
                                            }`}
                                            autoComplete="postal-code"
                                        />
                                    </div>
                                    <div className="mt-2 text-red-600">
                                        {errors?.[ZIP_CODE]?.message}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="form-section">
                            <div>
                                <h3 className="text-lg font-medium leading-6 text-gray-900">
                                    USPS Information
                                </h3>
                                <p className="mt-1 text-sm text-gray-500">
                                    {/* Let us know how you found us or which USPS
                                    representative you're working with. */}
                                    If you've been working with a USPS
                                    representative let us know who.
                                </p>
                            </div>
                            {/* <div className="input-row">
                                <label
                                    className="input-label"
                                    htmlFor={WORKING_WITH_USPS_REP}
                                >
                                    Have you been working with a United States
                                    Postal Service Representative?{" "}
                                    <span className="text-red-600">*</span>
                                </label>
                                <fieldset
                                    className="mt-2"
                                    onChange={handleChange}
                                >
                                    <div className="mt-2 space-x-2 flex flex-row">
                                        <div className="flex items-center">
                                            <input
                                                id="yes"
                                                type="radio"
                                                name={WORKING_WITH_USPS_REP}
                                                value="Yes"
                                                defaultChecked={
                                                    formState[
                                                        WORKING_WITH_USPS_REP
                                                    ] === "Yes"
                                                }
                                                required
                                                className="h-4 w-4 border-gray-300 text-xps-connect-primary-600 focus:ring-xps-connect-primary-500"
                                            />
                                            <label
                                                htmlFor="yes"
                                                className="ml-3 block text-sm font-medium text-gray-700"
                                            >
                                                Yes
                                            </label>
                                        </div>
                                        <div className="flex items-center">
                                            <input
                                                type="radio"
                                                name={WORKING_WITH_USPS_REP}
                                                value="No"
                                                defaultChecked={
                                                    formState[
                                                        WORKING_WITH_USPS_REP
                                                    ] === "No"
                                                }
                                                className="h-4 w-4 border-gray-300 text-xps-connect-primary-600 focus:ring-xps-connect-primary-500"
                                            />
                                            <label
                                                htmlFor="no"
                                                className="ml-3 block text-sm font-medium text-gray-700"
                                            >
                                                No
                                            </label>
                                        </div>
                                    </div>
                                </fieldset>
                            </div> */}
                            {/* {formState[WORKING_WITH_USPS_REP] === "Yes" && ( */}
                            <div className="input-row">
                                <label
                                    className="input-label"
                                    htmlFor={USPS_REPRESENTATIVE}
                                >
                                    Search and select your USPS representative{" "}
                                    {/* <span className="text-red-600">*</span> */}
                                </label>
                                <div className="input-container">
                                    <ComboboxAutocomplete
                                        name={USPS_REPRESENTATIVE}
                                        handleChange={handleChange}
                                        rep={repUsername}
                                        inputErrors={errors}
                                    />
                                </div>
                            </div>
                            {/* )} */}
                            {/* {formState[WORKING_WITH_USPS_REP] === "No" && (
                                <div className="input-row">
                                    <label
                                        className="input-label"
                                        htmlFor={HOW_DID_YOU_HEAR_ABOUT_US}
                                    >
                                        How did you hear about XPS Ship?{" "}
                                        <span className="text-red-600">*</span>
                                    </label>
                                    <div className="input-container">
                                        <input
                                            type="text"
                                            name={HOW_DID_YOU_HEAR_ABOUT_US}
                                            value={
                                                formState[
                                                    HOW_DID_YOU_HEAR_ABOUT_US
                                                ]
                                            }
                                            onChange={handleChange}
                                            required
                                            className="input"
                                        />
                                    </div>
                                </div>
                            )} */}
                            {!formState[USPS_REPRESENTATIVE] && (<div className="input-row">
                                <div className="relative flex gap-x-3">
                                    <div className="flex h-6 items-center">
                                        <input
                                            id={SALES_REP_ASSIGNEMENT_CONSENT}
                                            name={SALES_REP_ASSIGNEMENT_CONSENT}
                                            type="checkbox"
                                            className="h-4 w-4 rounded border-gray-300 text-xps-connect-primary focus:ring-xps-connect-primary"
                                            onChange={handleChange}
                                            defaultChecked={formState[SALES_REP_ASSIGNEMENT_CONSENT]}
                                        />
                                    </div>
                                    <div className="text-sm leading-6">
                                        <label htmlFor={SALES_REP_ASSIGNEMENT_CONSENT} className="font-medium text-gray-900">
                                            I'd like USPS to reach out to help me access free supplies and schedule pickups.
                                        </label>
                                    </div>
                                </div>
                            </div>)}
                        </div>
                    </div>
                )}
                <div className="form-section">
                    <div className="relative flex gap-x-3">
                        <div className="flex h-6 items-center">
                            <input
                                id={AGREED_TO_TERMS}
                                name={AGREED_TO_TERMS}
                                type="checkbox"
                                className="h-4 w-4 rounded border-gray-300 text-xps-connect-primary focus:ring-xps-connect-primary"
                                onChange={handleChange}
                                defaultChecked={formState[AGREED_TO_TERMS]}
                            />
                        </div>
                        <div className="text-sm leading-6">
                            <label htmlFor={AGREED_TO_TERMS} className="font-medium text-gray-900">
                                I agree to the <a href={window.rootPath + '/terms-of-service'} className="text-sky-500 hover:text-sky-600 underline" target="_blank">terms &amp; conditions</a>.
                            </label>
                            <div className="my-2 text-red-600">
                                {errors?.[AGREED_TO_TERMS]?.message}
                            </div>
                        </div>
                    </div>
                    <div className="relative flex gap-x-3">
                        <div className="flex h-6 items-center">
                            <input
                                id={SUBSCRIBED_TO_MARKETING}
                                name={SUBSCRIBED_TO_MARKETING}
                                type="checkbox"
                                className="h-4 w-4 rounded border-gray-300 text-xps-connect-primary focus:ring-xps-connect-primary"
                                onChange={handleChange}
                                defaultChecked={formState[SUBSCRIBED_TO_MARKETING]}
                            />
                        </div>
                        <div className="text-sm leading-6">
                            <label htmlFor={SUBSCRIBED_TO_MARKETING} className="font-medium text-gray-900">
                                By submitting this form, I acknowledge that I am subscribing to emails related to Ecommerce.
                            </label>
                        </div>
                    </div>

                    {customer === CUSTOMER_NEW && (
                        <div className="relative flex gap-x-3">
                            <div className="flex h-6 items-center">
                                <input
                                    id="trustDevice"
                                    name="trustDevice"
                                    type="checkbox"
                                    className="h-4 w-4 rounded border-gray-300 text-xps-connect-primary focus:ring-xps-connect-primary"
                                    onChange={handleChange}
                                    defaultChecked={formState['trustDevice']}
                                />
                            </div>
                            <div className="text-sm leading-5">
                                <label htmlFor="trustDevice" className="font-medium text-gray-900 inline-flex items-center">
                                    <div>
                                        Trust this device
                                    </div>
                                    {' '}
                                    <QuestionMarkCircleIcon 
                                        className="ml-1 h-4 text-gray-400"
                                        title="When you check 'Trust this device' (computer, phone, tablet, etc), we will bypass two factor authentication for future logins with this device."
                                    />
                                </label>
                            </div>
                        </div>
                    )}

                </div>
                <div className="form-section">
                    {errors?.form?.message && (
                        <span className="text-red-600">{errors.form.message}</span>
                    )}
                    <button
                        className="button text-white bg-xps-connect-primary hover:bg-xps-connect-primary-600 mt-6"
                        type="submit"
                        value="submit"
                    >
                        Submit
                    </button>
                </div>
            </form>
            {isSubmitting && (
                <div className="absolute inset-0 bg-white/50 flex justify-center items-center">
                    <LoadingSpinner height="h-10" width="w-10" />
                </div>
            )}
        </div>
    );
}

const fetcher = (url, query) =>
    fetch(`${url}?keyword=${query}`).then((res) => res.json());

function ComboboxAutocomplete({
    name = "",
    handleChange,
    initialData = { data: [{ displayName: '', abbreviation: '', username: '' }] },
    rep = null,
    inputErrors = errorsInitialState,
}) {
    const [selected, setSelected] = useState(initialData.data[0]);
    const [query, setQuery] = useState(null);
    const { data, error } = useSWR(["salesreps", query], fetcher);
    const isLoading = !error && !data;

    const filteredResults =
        query === "" || query === null
            ? { data: initialData?.data?.slice(1) }
            : {
                  data: initialData?.data
                      ?.slice(1)
                      .filter((item) =>
                          item?.displayName
                              .toLowerCase()
                              .replace(/\s+/g, "")
                              .includes(
                                  query?.toLowerCase().replace(/\s+/g, "")
                              )
                      ),
              };

    const comboBoxData = name === USPS_REPRESENTATIVE ? data : filteredResults;

    useEffect(() => {
        if (selected && selected?.id !== 0) {
            handleChange(null, { type: name, value: selected });
        }
    }, [selected]);

    useEffect(() => {
        if (rep) {
            (async () => {
                try {
                    const res = await fetch(`salesreps?keyword=${rep}`);
                    const resJson = await res.json();

                    if (resJson.data.length > 0) {
                        setSelected(
                            resJson.data.find(
                                (repData) => repData.username.trim() === rep || repData.email === rep || repData.displayName === rep || repData.id === rep
                            )
                        );
                    } else {
                        console.error("No rep found");
                    }
                } catch (error) {
                    console.error(error);
                }
            })();
        }
    }, []);

    return (
        <div>
            <Combobox value={selected} onChange={setSelected} name={name}>
                <div className="relative mt-1">
                    <div>
                        <Combobox.Input
                            className={`input${
                                (inputErrors?.[STATE] && name === STATE) ||
                                (inputErrors?.[USPS_REPRESENTATIVE] &&
                                    name === USPS_REPRESENTATIVE)
                                    ? " input-invalid"
                                    : " border-gray-400 text-inherit focus:border-xps-connect-primary focus:ring-xps-connect-primary"
                            }`}
                            displayValue={(item) => {
                                const displayName = capitalizeNameLowerCaseRest(item?.displayName) || "";
                                let repState = "";
                                
                                if (
                                    name === USPS_REPRESENTATIVE &&
                                    item?.username &&
                                    usStates.data.find(
                                        (usState) =>
                                            usState.abbreviation ===
                                            item?.username.slice(0, 2).toUpperCase()
                                    )?.displayName
                                ) {
                                    repState = ` - ${
                                        usStates.data.find(
                                            (usState) =>
                                                usState.abbreviation ===
                                                item?.username.slice(0, 2).toUpperCase()
                                        )?.displayName
                                    }`;
                                }
                                
                                return `${displayName}${repState}`;
                            }}
                            onChange={(event) => {
                                const value =
                                    event.target.value === ""
                                        ? null
                                        : event.target.value;
                                setQuery(value);
                            }}
                            autoComplete={name === STATE ? "address-level1" : "off"}
                        />
                        <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
                            {name === USPS_REPRESENTATIVE && isLoading && (
                                <LoadingSpinner />
                            )}
                            <ChevronUpDownIcon
                                className="h-5 w-5 text-gray-400"
                                aria-hidden="true"
                            />
                        </Combobox.Button>
                    </div>
                    <Transition
                        as={Fragment}
                        leave="transition ease-in duration-100"
                        leaveFrom="opacity-100"
                        leaveTo="opacity-0"
                    >
                        <Combobox.Options className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white py-1 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm">
                            {comboBoxData?.data?.length === 0 &&
                            query !== "" ? (
                                <div className="relative cursor-default select-none py-2 px-4 text-gray-700">
                                    Nothing found.
                                </div>
                            ) : (
                                comboBoxData?.data?.map((item, index) => (
                                    <Combobox.Option
                                        key={index}
                                        className="relative cursor-pointer select-none py-2 pl-10 pr-4 ui-active:bg-xps-connect-primary ui-active:text-white ui-not-active:text-gray-900"
                                        value={item}
                                    >
                                        {({ selected }) => {
                                            const displayName = capitalizeNameLowerCaseRest(item?.displayName) || "";
                                            let repState = "";
                                            
                                            if (
                                                name === USPS_REPRESENTATIVE &&
                                                item?.username &&
                                                usStates.data.find(
                                                    (usState) =>
                                                        usState.abbreviation ===
                                                        item?.username.slice(0, 2).toUpperCase()
                                                )?.displayName
                                            ) {
                                                repState = ` - ${
                                                    usStates.data.find(
                                                        (usState) =>
                                                            usState.abbreviation ===
                                                            item?.username.slice(0, 2).toUpperCase()
                                                    )?.displayName
                                                }`;
                                            }
                                            return (
                                                <>
                                                    <span className="block truncate ui-selected:font-medium ui-not-selected:font-normal">
                                                        {displayName}
                                                        {repState}
                                                    </span>
                                                    {selected ? (
                                                        <span className="absolute inset-y-0 left-0 flex items-center pl-3 ui-active:text-white ui-not-active:text-xps-connect-primary">
                                                            <CheckIcon
                                                                className="h-5 w-5 ui-active:text-white ui-not-active:text-whitetext-xps-connect-primary"
                                                                aria-hidden="true"
                                                            />
                                                        </span>
                                                    ) : null}
                                                </>
                                            );
                                        }}
                                    </Combobox.Option>
                                ))
                            )}
                        </Combobox.Options>
                    </Transition>
                </div>
            </Combobox>
        </div>
    );
}

function LoadingSpinner({ height, width }) {
    return (
        <svg
            className={`${height ? height : "h-5"} ${
                width ? width : "w-5"
            } animate-spin text-gray-500`}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
        >
            <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
            ></circle>
            <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
        </svg>
    );
}

function PasswordToggle({ showPassword, setShowPassword }) {
    return (
        <div
            className="cursor-pointer absolute inset-y-0 right-0 flex items-center pr-3 py-3"
            onClick={() => setShowPassword(!showPassword)}
        >
            {showPassword ? (
                <PasswordEyeClosed height="h-5" width="w-5" />
            ) : (
                <PasswordEyeOpen height="h-5" width="w-5" />
            )}
        </div>
    );
}

function PasswordEyeOpen({ height, width }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6"
        >
            <path d="M12 15a3 3 0 100-6 3 3 0 000 6z" />
            <path
                fillRule="evenodd"
                d="M1.323 11.447C2.811 6.976 7.028 3.75 12.001 3.75c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113-1.487 4.471-5.705 7.697-10.677 7.697-4.97 0-9.186-3.223-10.675-7.69a1.762 1.762 0 010-1.113zM17.25 12a5.25 5.25 0 11-10.5 0 5.25 5.25 0 0110.5 0z"
                clipRule="evenodd"
            />
        </svg>
    );
}

function PasswordEyeClosed({ height, width }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            className="w-6 h-6"
        >
            <path d="M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z" />
            <path d="M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z" />
            <path d="M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z" />
        </svg>
    );
}
